var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import cx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { Box, Typography } from '@material-ui/core';
import { Company } from './Company';
import { SocialMedia } from './Socialmedia';
import { ImgWithFallback, Links } from '../../components';
import { InitIntl, ReactIntl } from '../../helpers';
import { useStyles } from '../../models/styles/footer';
const header = [
    { name: 'Company', id: 'ca' },
    { name: 'Products', id: 'po' },
    { name: 'Assistive Tools', id: 'as' },
    { name: 'Resources', id: 're' }
];
const mainTools = [
    { name: 'AI Audio', url: '/ai-audio/start' },
    { name: 'AI Chat', url: '/ai-chat/start' },
    { name: 'AI Design', url: '/ai-design/start' },
    { name: 'AI Draw', url: '/imagemaker/start/ai-draw' },
    { name: 'AI Writer', url: '/copywriter/start' },
    { name: 'Design Maker', url: '/designmaker/start' },
    { name: 'Face Swapper', url: '/faceswapper' },
    { name: 'Image Maker', url: '/imagemaker/start' },
    {
        name: 'Image To Text',
        url: '/copywriter/start/social-media/caption-generator'
    },
    { name: 'Logo Maker', url: '/logomaker/start' },
    { name: 'Speech Maker', url: '/speechmaker/start' },
    { name: 'Video Maker', url: '/videomaker/start' }
];
const assistiveTools = [
    { name: 'Calendar', url: '/calendar' },
    { name: 'Color Matcher', url: '/colors' },
    { name: 'Font Pairer', url: '/fonts' },
    { name: 'Graphic Maker', url: '/graphicmaker' }
];
const company = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Cookie Policy', url: '/policy/cookie-policy' },
    { name: 'License Agreement', url: '/policy/license-agreement' },
    { name: 'Privacy Policy', url: '/policy/privacy-policy' },
    {
        name: 'Security Disclosure Policy',
        url: '/policy/security-disclosure-policy'
    },
    { name: 'Terms of Use', url: '/policy/terms-of-use' },
    { name: 'Contact Us', url: '/contact-us' }
];
const resources = [
    { name: 'Affiliate', url: '/affiliate' },
    { name: 'Blog', url: 'https://designs.ai/blog/' },
    { name: 'Design Types', url: 'https://designs.ai/design-types' },
    { name: "Do's and Dont's", url: '/dos-and-donts' },
    { name: 'Inspire', url: 'https://inspire.designs.ai/' },
    { name: 'Faq', url: '/faq' },
    { name: 'For Agencies', url: '/agency' }
];
const daiUrl = 'https://designs.ai';
const Footer = ({ currentLanguage, Link, isAbsolute }) => {
    const classes = useStyles();
    const [index, setIndex] = useState(0);
    const [intl, setIntl] = useState(InitIntl());
    const fetchIntel = useCallback((lng) => __awaiter(void 0, void 0, void 0, function* () {
        setIntl(yield ReactIntl(lng || 'en', 'footer'));
    }), []);
    useEffect(() => {
        fetchIntel(currentLanguage);
    }, [currentLanguage]);
    const handleClick = (key) => setIndex(key === index ? -1 : key);
    return (React.createElement(Box, { sx: {
            gap: '24px',
            display: 'flex',
            flexDirection: 'column',
            padding: { xs: '30px 0 0 0 ', md: '50px 0 0 0' }
        } },
        React.createElement(Box, { sx: {
                width: 'auto',
                display: 'flex',
                padding: { xs: 0, lg: '0 80px' },
                flexDirection: { xs: 'column', lg: 'row' }
            } },
            React.createElement(Box, { component: 'hr', sx: {
                    order: 2,
                    margin: '24px 0',
                    opacity: 0.3,
                    width: 'auto%',
                    borderTop: '1px solid #A3A3A3',
                    display: { xs: 'none', md: 'flex', lg: 'none' }
                } }),
            React.createElement(Box, { sx: {
                    width: { xs: 'auto', lg: '30%', xl: '50%' },
                    display: 'flex',
                    flexDirection: 'column',
                    order: { xs: 2, lg: 1 },
                    padding: { xs: '24px', lg: 0 }
                } },
                React.createElement(Box, { sx: {
                        gap: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        width: { xs: '100%', lg: '200px' }
                    } },
                    React.createElement(Links, { to: `${isAbsolute ? daiUrl : ''}/`, Link: Link, className: classes.responsive_margin },
                        React.createElement(ImgWithFallback, { alt: 'logo', width: '177', height: '46', src: 'https://assets.designs.ai/images/dsai-logo/default.webp', fallback: 'https://assets.designs.ai/images/dsai-logo/default.png' })),
                    React.createElement("div", { className: classes.description }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'designsai_description',
                        defaultMessage: 'Designs.ai is part of a creative ecosystem on a mission to make design easy for everyone.'
                    })),
                    React.createElement(SocialMedia, null))),
            React.createElement(Box, { sx: {
                    width: { xs: 'auto', lg: '70%', xl: '60%' },
                    justifyContent: 'flex-end',
                    display: 'flex',
                    order: { xs: 1, lg: 2 },
                    padding: { xs: '0 24px', lg: 0 }
                } },
                React.createElement(Box, { sx: {
                        display: 'flex',
                        flexWrap: 'nowrap',
                        justifyContent: 'space-between',
                        gap: { xs: '24px', sm: '24px', md: '70px' },
                        width: { xs: '100%', xl: '-webkit-fill-available' },
                        flexDirection: { xs: 'column', sm: 'column', md: 'row' }
                    } }, header.map((h, i) => (React.createElement(Box, { key: i, sx: {
                        width: { xs: '100%', sm: '100%', md: '150px', lg: '150px' }
                    } },
                    React.createElement("div", { onClick: (e) => {
                            e.preventDefault();
                            handleClick(i);
                        } },
                        React.createElement(Typography, { sx: {
                                marginBottom: {
                                    xs: index === i ? '20px' : 0,
                                    sm: index === i ? '20px' : 0,
                                    md: '20px'
                                }
                            }, className: cx(classes.h6) }, intl === null || intl === void 0 ? void 0 :
                            intl.formatMessage({
                                id: `${h.name}`,
                                defaultMessage: `${h.name}`
                            }),
                            React.createElement(FaChevronDown, { className: cx(index === i ? classes.rotate180 : '', classes.chevron) }))),
                    React.createElement(Box, { sx: {
                            gap: '8px',
                            display: 'flex',
                            flexDirection: 'column',
                            height: {
                                xs: index === i ? 'max-content' : '0px',
                                sm: index === i ? 'max-content' : '0px',
                                md: 'max-content'
                            },
                            overflow: 'hidden'
                        } }, (h.id === 'ca'
                        ? company
                        : h.id === 'po'
                            ? mainTools
                            : h.id === 'as'
                                ? assistiveTools
                                : h.id === 're'
                                    ? resources
                                    : []).map((c, i) => {
                        const isOpenNewTab = c.name === 'Blog' || c.name === 'Inspire';
                        return (React.createElement(Links, { to: isAbsolute
                                ? c.url.startsWith('https')
                                    ? c.url
                                    : `${daiUrl}${c.url}`
                                : c.url, Link: Link, target: isOpenNewTab ? '_blank' : null, outside: h.id !== 'ca', rel: isOpenNewTab ? 'noreferrer noopener' : 'noopener', key: i, className: classes.linkItem }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                            id: `${c.name}`,
                            defaultMessage: `${c.name}`
                        })));
                    })))))))),
        React.createElement(Company, { intl: intl })));
};
export default Footer;
//# sourceMappingURL=index.js.map